<template>
  <center>
    <div class="card card-body agatrs-card-style">
      <Header pageTitle="Users" class="card-container"></Header>

      <user-modal ref="modal"></user-modal>

      <div class="row no-bottom-margin">
        <div class="col-md-4 col-sm-6 col-xs-6">
          <base-button
            hidden
            size="lg"
            class="btn-dark float-sm-none float-md-left more-margin-top"
            @click.native="viewItem(0)"
            >Add</base-button
          >
        </div>

        <div class="col-md-3 offset-md-5">
          <label for="searchBox">Search:</label>
          <el-input
            id="searchBox"
            type="search"
            class="mb-3 search-input"
            clearable
            prefix-icon="el-icon-search"
            @input="search()"
            v-model="searchText"
            placeholder="Search all Users..."
            v-b-popover.hover.top="
              'Search results appear immediately upon typing.'
            "
          ></el-input>
        </div>
      </div>
      <div class="row">
        <card class="card-plain" body-classes="table-full-width">
          <el-table
            ref="table"
            :data="paginatedUsers.results"
            :default-sort="{ prop: 'question', order: 'descending' }"
            role="table"
        aria-label="Orders Table"
          >
            <el-table-column :min-width="140" align="left" label="Actions">
              <div slot-scope="props" class="table-actions">
                <el-tooltip
                  content="Edit User Account"
                  :open-delay="300"
                  effect="light"
                  placement="top"
                >
                  <base-button
                    class="btn btn-icon btn-fab btn-default btn-sm btn-link"
                    @click.native="viewItem(props.row.id)"
                  >
                    <i class="tim-icons icon-pencil"></i>
                  </base-button>
                </el-tooltip>
              </div>
            </el-table-column>

            <el-table-column
              v-for="column in tableColumns"
              sortable
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            ></el-table-column>
          </el-table>
          <div
            slot="footer"
            class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            "
          >
            <el-select
              class="select-primary mb-3 pagination-select"
              v-model="pageCount"
              @change="getPaginateUsers()"
              placeholder="Per page"
            >
              <el-option
                class="select-primary"
                v-for="item in pageCountOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>

            <base-pagination
              v-model="paginatedUsers.currentPage"
              @input="getPaginateUsers()"
              :perPage="paginatedUsers.pageSize"
              :pageCount="paginatedUsers.pageCount"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </center>
</template>

<script>
import Header from "@/components/App/Header.vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import Util from "@/util/util";
import { mapGetters, mapActions } from "vuex";
import UserModal from "@/components/App/account/UserModal.vue";
import { BasePagination, BaseButton, EditableCell } from "@/components";

export default {
  name: "SuperAdminUsers",
  components: {
    Header,
    UserModal,
    BaseButton,
    BasePagination,
    EditableCell,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      pageCount: 5,
      searchText: "",
      pageCountOptions: [],
      tableColumns: [
        {
          prop: "email",
          label: "Email",
          minWidth: 120,
          scope: "col"
        },
        {
          prop: "firstName",
          label: "First Name",
          minWidth: 120,
          scope: "col"
        },
        {
          prop: "lastName",
          label: "Last Name",
          minWidth: 120,
          scope: "col"
        },
           {
          prop: "organizationName",
          label: "Organization",
          minWidth: 180,
          scope: "col"
        },
        {
          prop: "approvalStatusName",
          label: "Approval Status",
          minWidth: 180,
          scope: "col"
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      paginatedUsers: "users/paginatedUsers",
      jointStaffOrganizations: "organization/jointStaffOrganizations",
      approvalStatuses: "approvalStatus/approvalStatuses",
      sponsorUsers: "users/sponsorUsers",
    }),

    selectedPageCount() {
      return this.pageCount;
    },
  },

  created() {
    this.pageCountOptions = Util.getInitialPaginationInfo().perPageOptions;

    this.getAllUsersPaginate({
      pageNumber: this.paginatedUsers.currentPage
        ? this.paginatedUsers.currentPage
        : 1,
      pageCount: this.paginatedUsers.pageSize
        ? this.paginatedUsers.pageSize
        : this.pageCount,
      searchText: this.searchText ? this.searchText : "",
    });

    this.getRoles();

      this.getJointStaffOrganizations();

      this.getApprovalStatuses();

      this.getSponsorUsers();
  },
  watch: {},
  methods: {
    ...mapActions({
      getAllUsersPaginate: "users/getAllUsersPaginate",
       getUser: "users/getUser",
      getSponsorUsers: "users/getSponsorUsers",
      getJointStaffOrganizations: "organization/getJointStaffOrganizations",
      getApprovalStatuses: "approvalStatus/getApprovalStatuses",
    }),
    
    viewItem(id) {
      this.getUser(id);

      this.$refs.modal.open();
    },

    getPaginateUsers() {
      var paginationInfo = {
        pageNumber: this.paginatedUsers.currentPage
          ? this.paginatedUsers.currentPage
          : 1,
        pageCount: this.pageCount,
        searchText: this.searchText ? this.searchText : "",
      };

      return this.getAllUsersPaginate(paginationInfo);
    },   

    search() {
      clearTimeout(this.searchTimeOut);

      var self = this;
      self.searchTimeOut = setTimeout(function () {
        self.paginatedUsers.currentPage = 1;
        self.getPaginateUsers();
      }, 1000);
    },
  },
};
</script>

<style>
.el-table .cell {
  overflow: visible !important;
}
</style>
